import React from 'react'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import DialogCurrencySelector from 'components/DialogCurrencySelector'
import * as selectors from 'selectors'
import * as configActions from 'actions/config'

const MAIN_CURRENCIES = ['EUR', 'USD', 'BTC']

const MainCurrencySelector = ({
  isOpen,
  onChange,
  handleRequestClose,
  currencies,
  classes,
}) => {
  const currenciesOrdered = currencies.map(c => ({
    ...c,
    priority: MAIN_CURRENCIES.indexOf(c.code) > -1 ? 1 : 0,
  }))
  return (
    <DialogCurrencySelector
      open={isOpen}
      currencies={currenciesOrdered}
      onChange={onChange}
      onRequestClose={handleRequestClose}
    />
  )
}

const mapStateToProps = state => ({
  currencies: selectors.fiatArray(state),
  isOpen: state.config.mainCurrencySelectorOpen,
})

const mapDispatchToProps = dispatch => ({
  onChange: cur => dispatch(configActions.setConfig({ mainCurrency: cur })),
  handleRequestClose: () =>
    dispatch(configActions.setConfig({ mainCurrencySelectorOpen: false })),
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  MainCurrencySelector
)



// WEBPACK FOOTER //
// ./src/components/MainCurrencySelector.js